<button data-testid="expand-collapse-toggle_button"
  emphasis="minimal"
  ttButton
  variant="secondary"
  [ttTooltip]="(isAnyExpanded() ? 'CollapseAllSections' : 'ExpandAllSections') | transloco"
  (click)="toggleExpandCollapse()">
  @if (isAnyExpanded()) {
    <mat-icon [icon]="'collapse-all'" [iconSize]="16" />
  } @else {
    <mat-icon [icon]="'expand-all'" [iconSize]="16" />
  }
  <span class="tt-expand-collapse-toggle_button-label">{{
    (isAnyExpanded() ? 'CollapseAllSections' : 'ExpandAllSections') | transloco
  }}</span>
</button>
